module.exports = __WEBPACK_EXTERNAL_MODULE__meltwater_applet_base__;